import React from 'react'
import { Checkbox } from 'antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'

interface OneZeroCheckboxProps {
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  indeterminate?: boolean
  children?: React.ReactNode
  readOnly?: boolean
}

const OneZeroCheckbox: React.FC<OneZeroCheckboxProps> = ({
  value,
  onChange,
  disabled,
  indeterminate,
  children,
  readOnly = false,
}) => {
  const isChecked = value === '1'

  const handleCheckChange = (e: CheckboxChangeEvent) => {
    const newValue = e.target.checked ? '1' : '0'
    if (onChange) {
      onChange(newValue)
    }
  }

  return (
    <Checkbox
      checked={isChecked}
      onChange={handleCheckChange}
      disabled={disabled || readOnly}
      indeterminate={indeterminate}
    >
      {children}
    </Checkbox>
  )
}

export default OneZeroCheckbox
import React from 'react'
import { Checkbox } from 'antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox'

interface OneZeroCheckboxProps {
  value?: string
  onChange?: (value: string) => void
  disabled?: boolean
  indeterminate?: boolean
  children?: React.ReactNode
  readOnly?: boolean
}

const OneZeroCheckbox: React.FC<OneZeroCheckboxProps> = ({
  value,
  onChange,
  disabled,
  indeterminate,
  children,
  readOnly = false,
}) => {
  const isChecked = value === '1'

  const handleCheckChange = (e: CheckboxChangeEvent) => {
    const newValue = e.target.checked ? '1' : '0'
    if (onChange) {
      onChange(newValue)
    }
  }

  return (
    <Checkbox
      checked={isChecked}
      onChange={handleCheckChange}
      disabled={disabled || readOnly}
      indeterminate={indeterminate}
    >
      {children}
    </Checkbox>
  )
}

export default OneZeroCheckbox
